import styled from 'styled-components';
import { AppBar, Toolbar as MuiToolbar, Typography } from '@material-ui/core';
import { PRIMARY, SECONDARY } from '../../shared/styles/colors';

export const Wrapper = styled(AppBar)`
  transition: all 500ms ease-in-out !important;
  height: 0;
  ${({ canshow }) => canshow && `height: 96px;`};
  @media screen and (min-width: 600px) {
    ${({ canshow }) => canshow && `height: 160px;`};
  }
  &.MuiAppBar-positionFixed {
    top: auto;
    overflow: hidden;
    bottom: 0;
    background-color: #F3F7FC;
  }
`;

export const Toolbar = styled(MuiToolbar)`
  &.MuiToolbar-root {
    background-color: #F3F7FC;
    margin: auto;
    height: 100%;
    width: 100%;
    justify-content: space-between;
    max-width: 1033px;
    @media screen and (min-width: 1024px) {
      justify-content: center;
    }
  }
`;

export const Text = styled(Typography)`
  &.MuiTypography-h6 {
    font-size: 18px;
    margin-right: 24px;
    font-weight: 600;

    .primary {
      color: ${PRIMARY};
    }

    .secondary {
      color: ${SECONDARY};
    }
  }
`;
